export type HdrCapabilities = {
  display: "hdr" | "sdr" | "unknown";
  hevc: "yes" | "no" | "unknown";
  hdr10: "yes" | "no" | "unknown";
  hlg: "yes" | "no" | "unknown";
  dolbyVision: "yes" | "no" | "unknown";
};

export function detectWebHdrCapabilities(): HdrCapabilities {
  if (typeof document === "undefined" || typeof window === "undefined") {
    return { display: "unknown", hevc: "unknown", hdr10: "unknown", hlg: "unknown", dolbyVision: "unknown" };
  }
  const video = document.createElement("video");
  const highRange = typeof window.matchMedia === "function" && (
    window.matchMedia("(dynamic-range: high)").matches ||
    window.matchMedia("(video-dynamic-range: high)").matches
  );
  const canPlay = (codecs: string) => video.canPlayType(`video/mp4; codecs="${codecs}"`) !== "";
  return {
    display: highRange ? "hdr" : "sdr",
    hevc: canPlay("hvc1.1.6.L93.B0") ? "yes" : "no",
    hdr10: highRange && canPlay("hvc1.2.4.L153.B0") ? "yes" : "no",
    hlg: highRange && canPlay("hvc1.2.4.L153.B0") ? "yes" : "no",
    dolbyVision: highRange && canPlay("dvh1.05.06") ? "yes" : "no",
  };
}

export function formatHdrSourceLabel(rangeType?: string) {
  const value = rangeType?.trim();
  return value || "SDR / unknown";
}
